<template>
	<div class="personnelManage-body">
		<!-- <div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">店铺名称：{{shopName}}</span> -->
				<!-- <el-input
					v-model="shopName"
					class="name-input"
					disabled
					size="mini"
				></el-input> -->
			<!-- </div>
		</div> -->
		<Search @getTableData="getTableDataHandle" :sessionStoreId='sessionStoreId' @getParamsData="getParamsData"></Search>
		<div class="table-div">
			<!-- <div class="btn-box1">
				<el-button
					type="primary"
					class="fx-big-btn"
					size="mini "
					v-if="(flag === 'true') || (flag === 'false' && AuthorityList['01_0001_0001_00'])"
					@click='addClick'
					plain>添加
				</el-button>
				<el-button
					type="primary"
					class="fx-big-btn"
					v-if="(flag === 'true') || (flag === 'false' && AuthorityList['01_0001_0001_00'])"
					size="small "
					@click="deleteList"
					plain>删除
				</el-button>
			</div> -->
			<div class="table-box">
				<el-table
					:stripe='true'
					size='mini'
					ref='multipleTable'
					class="grid-content"
					@row-dblclick='rowClick'
					:data="tableData"
					:height="tableHeight"
					border
					@selection-change="handleSelectionChange">
					<el-table-column
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="staffName"
						label="员工名称"
						align="center"
						min-width="160">
					</el-table-column>
					<el-table-column
						prop="staffNumber"
						label="员工编号"
						align="center"
						min-width="160">
					</el-table-column>
					<el-table-column
						prop="tel"
						label="联系方式"
						align="center"
						min-width="160">
					</el-table-column>
					<el-table-column
						prop="staffDisabled"
						label="员工状态"
						align="center"
						min-width="160">
						<template slot-scope='scope'>
							<span v-if='scope.row.staffDisabled === false' style="color:green">启用</span>
							<span v-if='scope.row.staffDisabled === true' style="color:red">停用</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="roleName"
						label="员工角色"
						align="center"
						min-width="160">
						<template slot-scope="scope">
							<span v-if='scope.row.roleCount > 1'>多角色</span>
							<span v-else>{{scope.row.roleName}}</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="staffDisabled"
						label="员工类型"
						align="center"
						min-width="180">
						<template slot-scope='scope'>
							<span v-if='scope.row.usertype === 0'>内控</span>
							<span v-if='scope.row.usertype === 1'>业务</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="subscriptionSendFlag"
						label="是否接收消息"
						align="center"
						min-width="180">
						<template slot-scope='scope'>
							<span v-if='scope.row.subscriptionSendFlag'>是</span>
							<span v-if='!scope.row.subscriptionSendFlag'>否</span>
						</template>
					</el-table-column>
					<!-- <el-table-column fixed="right" label="操作" width="200" align="center">
						<template slot-scope="scope">
							<el-button @click="modifyClick(scope.row)" type='text' size="mini"
							icon="el-icon-search">查看</el-button>
							<el-button v-if="(flag === 'true') || (flag === 'false' && AuthorityList['01_0001_0001_00'])" @click="deleteClick(scope.row)" type='text' size="mini" icon="el-icon-delete">删除</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<div style="height:40px">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page.number"
					:page-sizes="[20,40, 60, 100]"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>

		</div>
    <el-dialog top='60px' class="detail-dialog-title" :close-on-click-modal="false" :visible.sync="addModal" width='700px'>
			<!-- <modifyModal ref='addModal' :showData='showData' :dialogVisible.sync='addModal'></modifyModal> -->
			<viewModel ref='addModal' :isAdd='false' :isShow='addModal' :AuthorityList='AuthorityList' :addDisable="AuthorityList['01_0004_0002_00']" :isDisabled="AuthorityList['01_0004_0001_00']" :modifyData='modifyData' @showModal='showModal'></viewModel>
		</el-dialog>
		<el-dialog title="添加相关员工" top='60px' :before-close="cancelClick2" class="dialog-title" :visible.sync="bindModal" width='750px' :close-on-click-modal="false">
			<bindModal ref='bindModal' :sessionStoreId='sessionStoreId' @cancel='cancel' :isShow.sync='isShow' :bindData='bindData' :dialogVisible.sync='bindModal'></bindModal>
		</el-dialog>
	</div>
</template>
<script>
import viewModel from '@/components/personnelManage/viewModel.vue'
import Search from '@/components/storeSetting/relatedEmployees/Search.vue'
// import modifyModal from '@/components/storeSetting/relatedEmployees/FileDialog.vue'
import bindModal from '@/components/storeSetting/relatedEmployees/BindModal.vue'
export default {
	name: 'personnelManage',
	components: {
		Search, viewModel, bindModal
	},
	data () {
		return {
			flag: false,
			sessionStoreId: '',
			shopName: '',
			AuthorityList: {
				'01_0004_0001_00': false,
				'01_0004_0002_00': false,
				'01_0004_0003_00': false,
				'01_0004_0004_00': false,
				'01_0004_0005_00': false,
				'01_0004_0006_00': false,
				'01_0004_0007_00': false,
				'01_0004_0008_00': false
			},
			staffDisabled: 0,
			ids: [],
			staffName: '',
			tel: '',
			usertype: -1,
			addModal: false,
			bindModal: false,
			isShow: false,
			showData: {},
			bindData: {},
			tableData: [],
			tableHeight: '100%',
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			isAdd: false,
			modifyData: {}
		}
	},
	created () {
		this.shopName = window.sessionStorage.getItem('shopName')
		this.sessionStoreId = sessionStorage.getItem('storeid')
		this.getAuthority('01_0004_0000_00')
		if (this.sessionStoreId) {
			this.tableReload()
		}
	},
	methods: {
		showModal (data) {
			// console.log(data)
			this.addModal = data
			this.isAdd = data
			this.tableReload()
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		getAuthority (data) {
			this.flag = window.sessionStorage.getItem('isAdd')
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		deleteList () {
			console.log(this.ids)
			if (this.ids.length === 0) {
				this.$message.error('请先选择员工！')
			} else {
				this.$confirm('确认删除该员工', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let params = {
						shopid: this.sessionStoreId,
						relatedIds: this.ids
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIV}/shop/delRelatedShopUser`,
						data: params
					}).then(res => {
						console.log(res)
						if (res.resultFlag === true) {
							this.$message.success(res.message)
							this.tableReload()
						} else {
							this.$message.error(res.message)
						}
					})
				})
			}
		},
		getTableDataHandle (data) {
			console.log(data)
			this.tableData = data.staffs
			this.total = data.count
		},
		getParamsData (data) {
			this.page.number = data.page
			this.page.size = data.size
			this.staffDisabled = data.staffDisabled
			this.staffName = data.staffName
			this.usertype = data.usertype
			this.tel = data.tel
		},
		modifyClick (data) {
			this.modifyData = []
			this.modifyData = data
			// this.showData = []
			// this.showData = data
			this.addModal = true
			this.isAdd = false
		},
		handleSelectionChange (val) {
			let a = val
			this.ids = []
			for (let i = 0; i < a.length; i++) {
				this.ids.push(a[i].id)
			}
		},
		// addClick () {
		// 	this.bindModal = true
		// 	this.isShow = true
		// },
		// deleteClick (data) {
		// 	this.$confirm('确认删除该员工', '提示', {
		// 		confirmButtonText: '确定',
		// 		cancelButtonText: '取消',
		// 		type: 'warning',
		// 		closeOnClickModal: false
		// 	}).then(() => {
		// 		let params = {
		// 			shopid: this.sessionStoreId,
		// 			relatedIds: [data.id]
		// 		}
		// 		this.$store.dispatch('requestPost', {
		// 			url: `${this.$fxBaseApi.urlQIV}/shop/delRelatedShopUser`,
		// 			data: params
		// 		}).then(res => {
		// 			if (res.resultFlag === true) {
		// 				this.$message.success(res.message)
		// 				this.tableReload()
		// 			} else {
		// 				this.$message.error(res.message)
		// 			}
		// 		})
		// 	}).catch(() => {})
		// },
		cancel (data) {
			this.bindModal = data
			this.isShow = false
			if (data === false) {
				this.tableReload()
			}
		},
		cancelClick1 () {
			this.addModal = false
		},
		cancelClick2 () {
			this.bindModal = false
			this.isShow = false
		},
		tableReload () {
			let params = {
				sIds: [this.sessionStoreId],
				type: 0,
				staffName: this.staffName,
				usertype: this.usertype,
				staffDisabled: this.staffDisabled,
				tel: this.tel,
				page: this.page.number,
				size: this.page.size,
				subscriptionSendFlag: this.subscriptionSendFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data.staffs
					this.total = res.data.count
				} else {
					this.$message.error(res.message)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.personnelManage-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
	border-radius :0px 0px 10px 10px;

	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		padding-left :10px;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
    .personnelManage-header {
		border-bottom: 1px solid #dce2fd;
		height:78px;
		line-height: 78px;
		font-size: 20px;
		p {
			height: 100%
			box-sizing:border-box
			border-bottom: 3px solid var(--fx-primary-color);
			float left
		}
	}
	.table-div{
		display :flex;
		flex-direction :column;
		flex:1;
		.table-box{
			flex:1
			padding-bottom :10px;
		}
		.btn-box1{
			height:40px;
			line-height: 40px;
			width :90%;
			padding :10px;
			text-align :left
		}
	}


}

.related-employees-body {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	.features-btn-box {
		text-align left
		padding 20px 0
		box-sizing border-box
		border-top: 1px solid #dce2fd
	}
}
</style>
<style lang="stylus">
.detail-dialog-title {
	.el-dialog__header {
		display: none
	}
	.el-dialog__title {
		padding-left 10px;
		border: none !important;
	}
}
.personnelManage-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
